import { Checkbox, FormControlLabel, Tooltip } from "@mui/material";
import {useState } from "react";
import { useRevalidator } from "react-router-dom";

import useService from "../../../../../hooks/useService";
import ApiRequestErrorHandler from "../../../../global/ApiRequestErrorHandler";
import Colors from "../../../../global/Colors";
import LoadingIndicator from "../../../../global/LoadingIndicator";
import ResponseModal from "../../../../global/ResponseModal";
import { useDocumentPermissions } from "../hooks/useDocumentPermissions";

export default function ApprovalChecklist({ document }) {
  const documentRepository = useService("repositories/document-repository");
  const [isLoading, setIsLoading] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [uploadFailed, setUploadFailed] = useState(false);
  const [errorArray, setErrorArray] = useState([]);
  const { revalidate } = useRevalidator();
  const {canCheckDocuments, canViewCheckCheckbox, canApproveDocuments, canViewApprovalCheckbox} = useDocumentPermissions();

  const updateItem = async (e) => {
    setIsLoading(true);
    try {
      const body = {
        [e.target.name]: e.target.checked,
      };

      await documentRepository.patch(document.pk, body);
      setUploadSuccess(true);
      revalidate();
      setIsLoading(false);
    } catch (error) {
      setUploadFailed(true);
      setIsLoading(false);
      const errArr = ApiRequestErrorHandler(error ?? []);
      setErrorArray(errArr);
    }
  };

  const handleUploadSuccess = () => {
    setUploadSuccess(false);
  };

  return (
    <div className="flex flex-wrap">
      {canViewCheckCheckbox && <FormControlLabel
        name="checked"
        disabled={!canCheckDocuments}
        label={"Checked"}
        control={
          <Tooltip title="Set Document Checked">
            <Checkbox
              disabled={!canCheckDocuments}
              checked={document.checked}
              sx={{
                "&.MuiButtonBase-root.MuiCheckbox-root.Mui-checked.Mui-disabled": {
                  color: Colors.gray[400],
                },
              }}
            />
          </Tooltip>
        }
        onChange={(e) => updateItem(e)}
      />}
      {canViewApprovalCheckbox && <FormControlLabel
        name="approved"
        disabled={!canApproveDocuments}
        label={"Approved"}
        control={
          <Tooltip title="Set Document Approved">
            <Checkbox
              disabled={!canApproveDocuments}
              checked={document.approved}
              sx={{
                "&.MuiButtonBase-root.MuiCheckbox-root.Mui-checked.Mui-disabled": {
                  color: Colors.gray[400],
                },
              }}
            />
          </Tooltip>
        }
        onChange={(e) => updateItem(e)}
      />}
      <LoadingIndicator isLoading={isLoading} />
      <ResponseModal
        title="Update Success"
        description="The image/document was successfully updated"
        openBool={uploadSuccess}
        setOpenBool={setUploadSuccess}
        handleCloseFunc={handleUploadSuccess}
      />
      <ResponseModal
        title="Update failed"
        isError={true}
        openBool={uploadFailed}
        setOpenBool={setUploadFailed}
        errorMessage={errorArray}
      />
    </div>
  );
}
